import type { ReactNode } from 'react'

export interface ICreateArbitrationFormValues {
  navigationGraphId: string
  placement: string
}

export interface IABTestComposition {
  control_variation: {
    id: string
    traffic_share: number
  } | null
  tested_variations:
    | {
        id: string
        traffic_share: number
      }[]
    | null
}

export interface IABTestConfiguration {
  composition: IABTestComposition
  placement: string
}

export interface ICreateABTestArbitrationFormValues {
  controlVariation?: {
    id?: IOption
    trafficShare: number
  }
  placement: IOption
  testedVariations:
    | {
        id?: IOption
        trafficShare: number
      }[]
    | null
}

export interface IEngine {
  app_version?: string
  mapping: Record<string, string>
  updated_at: string
  updated_at_ts: number
  updated_by: string
}

export interface IABTestVariation {
  composition: IABTestComposition
  created_at: string
  created_at_ts: number
  created_by: string
  id: string
  traffic_allocation_control: number
  traffic_allocation_variations: number
  version: number
}

export interface IABTestEngine {
  [key: string]: IABTestVariation
}

export interface IVersionEngine {
  app_versions: string[] | null
  id: string
  mapping?: Record<string, string>
  updated_at: string
  updated_at_ts: number
  updated_by: string
}

export enum ENGINE_TYPE {
  AB_TEST = 'abtest',
  ARCHIVE = 'archive',
  DEVELOPMENT = 'development',
  REVIEW = 'review',
  VERSION = 'version',
}

export interface IEngineTab {
  engineType: ENGINE_TYPE
  name: ReactNode
}

export interface IEngineMapping {
  [key: string]: string
}

export interface IEngineFormValues {
  placements: {
    navigationGraph?: IOption
    placement?: IOption
  }[]
  version?: string
}

export interface IVersionEngineFormValues extends Pick<IEngineFormValues, 'placements'> {
  eligibilityError?: Record<string, string>
  force: boolean
  versions: string[]
}

export interface IGroupCreate {
  appKey: string
  appVersions: string[]
  deviceType: string
  force: boolean
  updatedBy?: string
}

export interface IGroupUpdate extends IGroupCreate {
  groupId: string
  mapping: IEngineMapping
}
